<template lang="pug">
v-container
  validation-observer(ref="obs" v-slot="{ invalid }")
    p Указанные сотрудники будут включены в единый договор об образовании.
      |  Вам необходимо будет ознакомить сотрудников с указанным договором.
    v-list-group(
      v-for="(item, idx) in employees"
      :key="item.id"
      eager
    )
      template(#activator)
        enrollment-employee-item(
          :item="item"
          :isValid="isValid(item, idx)"
          only-view
        )
      validation-observer
        v-list-item
          validation-provider(
            rules="required"
            name="Место жительства"
            vid="address"
            style="display: contents"
            v-slot="{ errors, valid }"
          )
            v-text-field.mr-2(
              v-model="item.address"
              label="Место жительства"
              dense rounded filled
              :error-messages="errors"
            )
          validation-provider(
            rules="required"
            name="Номер телефона"
            style="display: contents"
            vid="phone"
            v-slot="{ errors, valid }"
          )
            maska-field(
              v-model="item.phone"
              type="phone"
              :error-messages="errors"
              filled
              rounded
            )

    v-alert(type="info" text).
      Внимание! Вы сможете добавить сотрудников в запись (записать новых сотрудников),
      но на новый список сотрудников будет заключаться новый (отдельный договор).
      Поэтому, рекомендуем убедиться,
      что сформированный сейчас список все-таки является окончательным
    v-btn(
      text block
      target="_blank"
      :to="{ name: 'ConstructorDocumentView', params: { id: agreementId }}"
    ) Политика обработки персональных данных
    v-checkbox(
      v-model="checkbox"
      :label="checkboxLabel"
    )
    v-row.ma-0
      v-spacer
      v-btn(
        color="primary"
        :disabled="invalid || !checkbox"
        @click="successCallback"
      ) Продолжить
</template>

<script>
import EnrollmentEmployeeItem from '@/components/Enrollment/EnrollmentEmployeeItem.vue';
import MaskaField from '@/components/InputFields/MaskaField.vue';

export default {
  components: {
    MaskaField,
    EnrollmentEmployeeItem,
  },
  props: {
    agreementId: { type: Number, default: null },
    employees: { type: Array, default: () => ([]) },
    successCallback: { type: Function, default: () => {} },
  },
  data() {
    return {
      checkbox: false,
      checkboxLabel: 'Согласия слушателей на обработку персональных данных, в том числе указания их персональных данных в договоре получены',
    };
  },
  methods: {
    isValid(item, idx) {
      const val = this.$refs.obs?.observers[idx]?.flags?.valid;
      return !!(item.address && item.phone && val);
    },
  },
};
</script>
